import { SUPPORT_EMAIL, SUPPORT_PHONE } from "@/config";
import { WhatsAppButton } from "@/components/Cta";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-surface">
    <div className="nb-shell py-14">
      <div className="flex flex-col gap-4 border-b border-line pb-8 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="font-head text-xl tracking-[1px] text-ink">
            Night<span className="text-brand">Bay</span>
          </span>
          <p className="mt-2 text-sm text-ink3">Monthly overnight parking, Bengaluru.</p>
        </div>
        <WhatsAppButton label="WhatsApp us" testId="footer-whatsapp" className="!min-h-[44px] self-start sm:self-auto" />
      </div>

      <div className="grid gap-10 py-10 sm:grid-cols-2 lg:grid-cols-3">
        <div>
          <h3 className="font-head text-xs tracking-[0.14em] text-ink3">Company</h3>
          <p className="mt-3 text-sm text-ink2">Sahasamstapaka Private Limited</p>
          <p className="mt-1 font-mono text-xs text-ink3">GSTIN 29ABUCS6856L1Z3</p>
          <address className="mt-2 not-italic text-sm text-ink3">
            No. 11 (old No. 76), Diagonal Road, 3rd Block, Jayanagar, Ward No. 167 (old No. 59),
            Bengaluru, Karnataka 560011, India
          </address>
        </div>

        <div>
          <h3 className="font-head text-xs tracking-[0.14em] text-ink3">Contact</h3>
          <p className="mt-3 text-sm">
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-ink2 hover:text-brand">
              {SUPPORT_EMAIL}
            </a>
          </p>
          <p className="mt-1 text-sm">
            <a href={`tel:${SUPPORT_PHONE.replace(/\s/g, "")}`} className="text-ink2 hover:text-brand">
              {SUPPORT_PHONE}
            </a>
          </p>
          <h3 className="mt-6 font-head text-xs tracking-[0.14em] text-ink3">Grievance Officer</h3>
          <p className="mt-2 text-sm text-ink2">Prathibha K P</p>
          <p className="text-sm text-ink3">Prathibha.kp@nightbay.in</p>
          <p className="mt-1 text-xs text-ink3">
            Grievances may also be sent in writing to {SUPPORT_EMAIL}.
          </p>
          <h3 className="mt-6 font-head text-xs tracking-[0.14em] text-ink3">
            Data Protection Officer
          </h3>
          <p className="mt-2 text-sm text-ink2">Abinaya Balas · abinaya@bsrlawfirm.in</p>
        </div>

        <div>
          <h3 className="font-head text-xs tracking-[0.14em] text-ink3">Legal</h3>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <a data-testid="footer-about" href="/about" className="text-ink2 hover:text-brand">
                About us
              </a>
            </li>
            <li>
              <a data-testid="footer-terms" href="/terms" className="text-ink2 hover:text-brand">
                Terms &amp; Conditions
              </a>
            </li>
            <li>
              <a data-testid="footer-privacy" href="/privacy" className="text-ink2 hover:text-brand">
                Privacy
              </a>
            </li>
            <li>
              <a data-testid="footer-refunds" href="/terms#refunds" className="text-ink2 hover:text-brand">
                Cancellation &amp; Refunds
              </a>
            </li>
            <li>
              <a
                data-testid="footer-delete-account"
                href="/delete-account"
                className="text-ink2 hover:text-brand"
              >
                Delete my account
              </a>
            </li>
          </ul>
          <p className="mt-6 text-xs text-ink3">Coming soon on Android and iOS.</p>
        </div>
      </div>
    </div>
  </footer>
);
